export enum CWAlarmState {
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  OK = 'OK',
  ALARM = 'ALARM',
}

export type CWAlarmStatus = {
  value: CWAlarmState
  reason: string
  reasonData?: string // not in threshold crossed
  timestamp: string
}

export type CWAlarmDetail = {
  alarmName: string
  state: CWAlarmStatus
  previousState: CWAlarmStatus
  configuration: {
    description?: string
    metrics: [
      {
        id: string
        metricStat: {
          metric: {
            namespace: string
            name: string
            dimensions: {
              FunctionName: string
            }
          }
          period: number
          stat: string
        }
        returnData: true
      },
    ]
  }
}

export type CWAlertStatusChangeEventBusMeesageType = {
  version: string
  id: string
  'detail-type': string
  source: string
  account: string
  time: string
  region: string
  resources: [string]
  detail: CWAlarmDetail
}
